export default __webpack_public_path__ + "static/media/microgaming-logo.aeb7fbda.webp";